import { Socket } from "socket.io-client";

/**
 * Registers the client with the socket server
 * @param socket The socket instance
 * @param clientUUID The client UUID
 */
export function registerSocketClient(
  socket: Socket | null,
  clientUUID: string | null
): void {
  if (!socket || !clientUUID) {
    console.warn(
      "MonitoringService: Cannot register - No UUID or socket not connected",
      {
        hasUUID: !!clientUUID,
        socketConnected: socket?.connected || false,
        socket: socket,
      }
    );
    return;
  }

  if (!socket.connected) {
    console.warn("MonitoringService: Socket is not connected");
    return;
  }

  console.log("MonitoringService: Registering client with UUID:", clientUUID);

  // Emit without callback
  socket.emit("register_client", {
    uuid: clientUUID,
    type: "chatbot",
  });

  // Log that we attempted registration
  console.log("MonitoringService: Registration attempt sent");
}
